import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      label: 'DSGVO-konform',
      description: 'Datenschutz nach EU-Standards'
    },
    {
      icon: 'Lock',
      label: 'Enterprise-Sicherheit',
      description: 'Verschlüsselte Übertragung'
    },
    {
      icon: 'CheckCircle',
      label: 'Zertifiziert',
      description: 'ISO 27001 konform'
    }
  ];

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-medium text-muted-foreground text-center mb-4">
        Sicherheitsmerkmale
      </h3>
      <div className="grid grid-cols-1 gap-3">
        {securityFeatures?.map((feature, index) => (
          <div key={index} className="flex items-center space-x-3 p-3 bg-muted/50 rounded-lg">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-success/10 rounded-full flex items-center justify-center">
                <Icon name={feature?.icon} size={16} className="text-success" />
              </div>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground">{feature?.label}</p>
              <p className="text-xs text-muted-foreground">{feature?.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SecurityBadges;